<template>
  <div>
    <div class="order-home">
      <van-sticky>
        <div class="brand-card">
          <!-- 左边logo + 右边双行文字 -->
          <div class="brand-header">

              <!-- 左侧 LOGO 图片 -->
              <div class="logo-wrapper">
                  <!-- 实际使用时，将 src 替换为您的 logo 图片地址 -->
                  <img :src="logo" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
                  <!-- 如果图片加载失败，显示占位 (兼容) -->
                  <div class="logo-placeholder" style="display:none;">LOGO</div>
              </div>

              <!-- 右侧文字：公司名称 + 产品名称 两行 -->
              <div class="brand-text">
                  <span class="company-name">深圳市绘视医疗科技有限公司</span>
                  <span class="product-name">3D可视化分析服务</span>
              </div>

          </div>
        </div>

        <!-- <div style="padding-top:16px;padding-bottom:16px;background-color:#FFF;">
          <div class="order-home__title"><img :src="logo"><span>3D可视化分析服务</span></div>
        </div> -->
      </van-sticky>
      <div>
        <van-cell-group >
          <van-cell title="城市" is-link @click="toSelectArea" :value="areaLabel"/>
          <van-cell title="医院" is-link @click="toSelectHos" :value="hosLabel"/>
          <van-cell title="科室" is-link @click="toSelectDep" :value="depLabel"/>
          <van-field
            title-width="4.5em" 
            v-model="patient"
            label="患者"
            placeholder="请输入患者名称"
            maxlength="25" 
            clearable
            input-align="right"
          /> 
          <van-field
            title-width="4.5em" 
            v-model="medicalRecord"
            label="病历号"
            placeholder="请输入病历号"
            maxlength="50" 
            clearable
            input-align="right"
          />    
          <van-cell title="标配项">
            <template #label>
            <van-tag v-for="item in stItemData" :key="item.id" plain round type="primary">{{item.name}}</van-tag>
            </template>
          </van-cell>
          <van-cell title="可选配项" :border="false" value="请在医师的指导下选择">
          </van-cell>
          <van-checkbox-group v-model="csItems" direction="horizontal" style="padding: 0px 15px 10px 15px;font-size: 12px;">
            <van-checkbox v-for="item in ctItemData" :key="item.id" :name="item.id">{{item.name}}</van-checkbox>
          </van-checkbox-group>
          <div style="margin:0 16px;border-bottom: 1px solid #ebedf0;transform: scaleY(.5);"></div>
          <van-cell title="发票" is-link :value="invoiceLabel" @click="toSelectInvoice"/>
          <van-checkbox v-model="agreementSign" style="padding: 15px 15px 15px 13px;font-size: 14px;"><span style="color:#969799;" stopPropagation>已阅并同意</span><span style="font-weight:bold;" @click.stop="toAgreement">《用户服务条款》</span></van-checkbox>
        </van-cell-group>
      </div>
    </div>    
    <van-submit-bar
      :price="amount"
      label="金额："
      button-text="提交订单"
      @submit="onSubmit"
    />
    <van-popup v-model="showArea" round  position="bottom" :style="{ height: '350px' }">
      <van-skeleton :loading="cityLoading" :row="10" style="margin:30px 2px;">
        <van-picker show-toolbar title="选择城市" :columns="areaData" @confirm="doSelectArea" @cancel="showArea=false"/>
      </van-skeleton>
    </van-popup>
    <van-popup v-model="showHos" round  position="bottom" :style="{ height: '350px' }">
      <van-skeleton :loading="hosLoading" :row="10" style="margin:30px 2px;">
        <van-picker show-toolbar title="选择医院" :columns="hosData" @confirm="doSelectHos" @cancel="showHos=false"/>
      </van-skeleton>
    </van-popup>
    <van-popup v-model="showDep" round  position="bottom" >
      <van-skeleton :loading="depLoading" :row="10" style="margin:30px 2px;">
        <van-picker show-toolbar title="选择科室" :columns="depData" @confirm="doSelectDep" @cancel="showDep=false"/>
      </van-skeleton>
    </van-popup>

    <Agreement ref="agreement" v-model="showAgreement" />
    <Invoice ref="invoice" v-model="showInvoice" @success="invoiceCallback" />
    <Payment ref="payment" v-model="showPayment" @success="paymentCallback" />
    <Statement ref="statement" v-model="showStatement" @confirm="statementConfirm" />
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup, Card, SubmitBar, Toast, CellGroup, Field, Sticky, Cell, Tag, Popup, Picker, Skeleton, Dialog } from 'vant';
import logo from '@/assets/logo/logo.png'
import Agreement from '@/components/agreement'
import Invoice from './invoice'
import Payment from '@/components/payment'
import Statement from '@/components/statement'
import request from '@/utils/request'
export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Sticky.name]: Sticky,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Skeleton.name]: Skeleton,
    [Dialog.name]: Dialog,
    Agreement,
    Invoice,
    Payment,
    Statement
  },
  data() {
    return {
      logo,
      orderId: undefined,
      cityId: undefined,
      hosId: undefined,
      depId: undefined,
      patient: '',
      medicalRecord: '',
      csItems: [],
      areaLabel: '请选择城市',
      showArea: false,
      cityLoading: false,
      areaData: [],
      hosLabel: '请选择医院',
      showHos: false,
      hosLoading: false,
      hosData: [],
      depLabel: '请选择科室',
      showDep: false,
      depLoading: false,
      depLoaded: false,
      depData: [],
      stItemData: [],
      ctItemData: [],
      ctItemAmtMap: {},
      //收费标准
      chargeAmt: 0.00,
      amount: 0.00,
      invoiceLabel: '请选择发票',
      showInvoice: false,
      invoiceSign: 0,
      bodyType: undefined,
      bodyName: '',
      bodyCode: '',
      receiveEmail: '',
      showPayment: false,
      showStatement: false,
      showAgreement: false,
      agreementSign: false
    };
  },
  watch: {
    csItems(items){
      let ctChargeAmt = this.chargeAmt
      // this.stItemData.forEach(item => {
      //   amount += item.amt
      // })
      items.forEach(item => {
        ctChargeAmt += this.ctItemAmtMap[item]
      })
      this.amount = ctChargeAmt * 100
    }
  },
  methods: {
    toSelectArea() {
      this.showArea = true
      if(this.areaData.length != 0){
        return
      }
      this.cityLoading = true
      request({
        url: '/wxpubapis/apply/area',
        method: 'get'
      }).then(({data}) => {
        this.areaData = data
        this.cityLoading = false
      });
    },
    doSelectArea(texts, indexs){
      if(!texts || texts.length == 0){
        this.showArea = false
        return
      }
      let cityItem = this.areaData[indexs[0]].children[indexs[1]]
      if(cityItem.value != this.cityId){
        this.hosId = undefined
        this.hosLabel = '请选择医院'
      }
      this.cityId = cityItem.value 
      this.areaLabel = texts[0] + ' ' + texts[1]
      this.showArea = false
    },
    toSelectHos() {
      if(!this.cityId){
        Toast('请选择城市')
        return
      }
      this.showHos = true
      if(this.hosId != undefined){
        return
      }
      this.hosLoading = true
      request({
        url: '/wxpubapis/apply/hos',
        method: 'get',
        params: {cityId: this.cityId}
      }).then(({data}) => {
        this.hosData = data
        this.hosLoading = false
      });
    },
    doSelectHos(item){
      if(!item){
        this.showHos = false
        return
      }
      this.hosLabel = item.text
      this.hosId = item.value
      this.showHos = false
    },
    toSelectDep() {
      this.showDep = true
      if(this.depLoaded){
        return
      }
      this.depLoading = true
      request({
        url: '/wxpubapis/apply/dep',
        method: 'get'
      }).then(({data}) => {
        this.depData = data
        this.depLoading = false
        this.depLoaded = true
      });
    },
    doSelectDep(item){
      if(!item){
        this.showDep = false
        return
      }
      let ctItemAmtMap = {}
      item.ctItems.forEach(item => {
        ctItemAmtMap[item.id] = item.amt
      })
      this.ctItemAmtMap = ctItemAmtMap
      this.depLabel = item.text
      this.depId = item.value
      this.chargeAmt = item.chargeAmt
      this.stItemData = item.stItems
      this.ctItemData = item.ctItems
      this.csItems = [] 
      this.showDep = false
    },
    toSelectInvoice(){
      this.showInvoice = true
      this.$nextTick(() => {
        this.$refs.invoice.show()
      })
    },
    formatPrice(price) {
      return (price / 100).toFixed(2);
    },
    invoiceCallback(invoiceInfo){
      this.invoiceSign = 1
      this.bodyType = invoiceInfo.bodyType,
      this.bodyName = invoiceInfo.bodyName,
      this.bodyCode = invoiceInfo.bodyCode,
      this.receiveEmail = invoiceInfo.receiveEmail
      this.invoiceLabel = '电子('+(invoiceInfo.bodyType == 1 ? '个人' : '单位')+')'
    },
    toAgreement(){
      this.showAgreement = true
      this.$nextTick(() => {
        this.$refs.agreement.open()
      })
    },
    onSubmit() {
      if(!this.agreementSign){
        Toast('请阅读并同意用户服务条款')
        return
      }
      if(!this.cityId){
        Toast('城市不能为空')
        return
      }
      if(!this.hosId){
        Toast('医院不能为空')
        return
      }
      if(!this.depId){
        Toast('科室不能为空')
        return
      }
      if(!this.patient){
        Toast('患者不能为空')
        return
      }
      if(!this.medicalRecord){
        Toast('病历号不能为空')
        return
      }
      Dialog.confirm({
        title: '下单',
        message: '您确定要提交订单吗？',
      }).then(() => {
        this.showStatement = true
        this.$nextTick(() => {
          this.$refs.statement.open()
        })
      }).catch(() => {
        // on cancel
      });
    },
    statementConfirm(){
      // Dialog.confirm({
      //   title: '下单',
      //   message: '您确定要提交订单吗？',
      // }).then(() => {
        this._submitOrder()
      // }).catch(() => {
      //   // on cancel
      // });
    },
    _submitOrder(){
      Toast.loading({
        message: '订单提交中',
        forbidClick: true,
        overlay: true,
        duration: 0
      })
      request({
        // url: this.orderId ? `/wxpubapis/apply/order/${this.orderId}` : '/wxpubapis/apply/order',
        // method: this.orderId ? 'put' : 'post',
        url: '/wxpubapis/apply/order',
        method: 'post',
        data: {
          hosId: this.hosId,
          depId: this.depId,
          patient: this.patient,
          medicalRecord: this.medicalRecord,
          csItems: this.csItems,
          amount: this.amount,
          invoiceSign: this.invoiceSign,
          bodyType: this.bodyType,
          bodyName: this.bodyName,
          bodyCode: this.bodyCode,
          receiveEmail: this.receiveEmail
        }
      }).then(({data}) => {
        Toast.success()
        this.orderId = data.orderId
        this._toPay(data.amount)
      }).catch(() => Toast.clear())
    },
    _toPay(amount){
      this.showPayment = true
      this.$nextTick(() => {
        this.$refs.payment.show(this.orderId, amount)
      })
    },
    paymentCallback(){
      // location.reload()
      this.$router.replace('order')
    }
  }
};
</script>

<style lang="less">
.order-home {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  // padding: 46px 0px 0px;
  background: #fff;
  // background-color: #f4f4f4;
  
  &__title {
      // margin: 0 0 16px;
      font-size: 18px;

      img {
        width: 64px;
      }

      img, span {
        display: inline-block;
        vertical-align: middle;
      }
      span {
        padding-left: 8px;
        font-weight: bold;
      }
  }
  &__desc {
    margin: 0;
    color: rgba(69, 90, 100, 0.6);
    font-size: 14px;
  }

  &__title, &__desc {
    padding-left: 16px;
    font-weight: normal;
    line-height: 1;
    -webkit-user-select: none;
    user-select: none;
  }
  .prod-item {
    margin-left: 5px;
  }
  .van-tag {
    margin: 2px 3px;
    padding: 2px 6px;
  }
  .van-checkbox {
    margin: 2px 3px;
  }
}
</style>
